import {lazy} from 'react';

import {ReportAccessGuard, useImporterReportingIntegrations} from '@dms/shared-aftersales';

const Report = lazy(() => import('./components/Report'));

export function HondaMonthlyReport() {
  const {isHondaMonthlyReportEnabled, isHondaMonthlyReportLoading, isHondaMonthlyReportError} =
    useImporterReportingIntegrations();

  return (
    <ReportAccessGuard
      hasAccess={isHondaMonthlyReportEnabled}
      isLoading={isHondaMonthlyReportLoading}
      isError={isHondaMonthlyReportError}
      data-testid="hondaMonthlyReport"
    >
      <Report />
    </ReportAccessGuard>
  );
}
